import updateLocationSearch from './updateLocationSearch';

export default updateLocationSearch;
